var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styles},[_c('button',{staticClass:"cf-c-draggable-item__drag-area",attrs:{"tabindex":"-1"}},[_c('app-icon',{attrs:{"icon":"drag-icon"}})],1),_c('div',{staticClass:"cf-c-draggable-item__ctn"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }